export default __webpack_public_path__ + "static/files/数智健康养老系统PPT新.2284c909.pdf";